// src/components/ImageZoomModal.jsx
import React from "react";
import Modal from "react-modal";
import "../css/DynamicFormModal.css"

Modal.setAppElement("#root");

const ImageZoomModal = ({ isOpen, onRequestClose, imageUrl, alt = "Order Design" }) => {
  if (!imageUrl) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="dfm-modal image-zoom-modal"
      overlayClassName="dfm-overlay image-zoom-overlay"
      closeTimeoutMS={200}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      <div className="dfm-header">
        <button className="dfm-close" onClick={onRequestClose}>
          ×
        </button>
      </div>

      <div className="image-zoom-body">
        <img
          src={imageUrl}
          alt={alt}
          className="zoomed-image"
          onClick={onRequestClose}
          style={{ cursor: "zoom-out" }}
        />
      </div>
    </Modal>
  );
};

export default ImageZoomModal;